exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  overflow: hidden; }\n\n.main-container {\n  background-color: #f1f1f1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/main-container/main-container.component.scss
// module id = ../../../../../src/app/components/main-container/main-container.component.scss
// module chunks = main